import { ImportTypeLocationState } from '@/api/admin/location-state';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns/format';
import { ArrowUpDown } from 'lucide-react';
import { UpdateLocationState } from './sheet-update';

export const columns: ColumnDef<ImportTypeLocationState>[] = [
	{
		accessorKey: 'importTypeCompLocStateXrefId',
		header: ({ column }) => (
			<div className="flex justify-center">
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
				>
					Id
					<ArrowUpDown />
				</Button>
			</div>
		),
		cell: ({ row }) => {
			return (
				<div className="flex justify-center whitespace-nowrap font-medium">
					{row.original.importTypeCompLocStateXrefId}
				</div>
			);
		},
	},
	{
		accessorKey: 'companyLocationName',
		header: ({ column }) => (
			<div className="flex justify-center">
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
				>
					Company Location Name
					<ArrowUpDown />
				</Button>
			</div>
		),
		cell: ({ row }) => {
			return (
				<div className="flex justify-center whitespace-nowrap font-medium">
					{row.original.companyLocationName}
				</div>
			);
		},
	},
	{
		accessorKey: 'stateId',
		header: ({ column }) => (
			<div className="flex justify-center">
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
				>
					State Id
					<ArrowUpDown />
				</Button>
			</div>
		),
		cell: ({ row }) => {
			return (
				<div className="flex justify-center whitespace-nowrap font-medium">
					{row.original.stateId}
				</div>
			);
		},
	},
	{
		accessorKey: 'beginDate',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				Begin Date
				<ArrowUpDown />
			</Button>
		),
		cell: ({ row }) => {
			return (
				<div className="font-medium">
					{row.original.beginDate ? format(row.original.beginDate, 'P') : '---'}
				</div>
			);
		},
	},
	{
		accessorKey: 'expired',
		header: ({ column }) => (
			<div className="flex justify-center">
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
				>
					Expired
					<ArrowUpDown />
				</Button>
			</div>
		),
		cell: ({ row }) => {
			return (
				<div className="flex justify-center">
					<Checkbox checked={!!row.original.expired} disabled />
				</div>
			);
		},
	},
	{
		id: 'actions',
		cell: ({ row }) => (
			<div>{<UpdateLocationState locationState={row.original} />}</div>
		),
	},
];
